import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'El estado indica la situación operativa del equipo: "Operativo", "En taller", "Fuera de servicio".',
    'Mantené la lista corta: cada estado debe implicar una acción distinta para quien lo lee.',
  ],
  nextSteps: [
    'Asignar el estado correspondiente a cada equipo desde su ficha.',
    'Los mecánicos pueden actualizar el estado según la situación del equipo en las OTC.',
  ],
};

const ConfiguracionEstadosEquipo = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="estados"
      titulo="Estados de Equipo"
      descripcion="Estados operacionales de equipos"
      icon="fas fa-chart-line"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionEstadosEquipo;